import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/bookNowPage/BookNowComponent.tsx");
